function Sliders(config) {
  if (!config) return;

  this.sliders = $(config.sliders);
  this.interval = config.interval || 3000;
  this.width = this.sliders.children().eq(0).width();

  if (config.dots) {
    this.dots = $(config.dots);
  }

  /* 向最后添加第一张轮播 */
  if (this.sliders.children().length <= 1) {
    return;
  }
  this.sliders.children().eq(0).clone().appendTo(this.sliders);
  this.sliders.width(this.sliders.children().length * this.width + 'px');

  /* 设置轮播 */
  this.sliderWidth = $(this.sliders.children()[0]).width();
  this.sliders.css('left', '0');
  this.current = 0;
  var _this = this;
  this.intervalTimer = interval();

  if (config.operates) {
    var animating = false;
    this.prev = $(config.operates.prev);
    this.next = $(config.operates.next);

    this.prev.on('click', function () {
      if (animating) return;
      animating = true;

      var timer = _this.intervalTimer,
        current = _this.current;
      clearIntervalCustom(timer);
      _this.intervalTimer = null;
      if (current === 0) {
        current = _this.sliders.children().length - 1;
        _this.sliders.css('left', -current * _this.width + 'px');
      }
      current--;
      _this.current = current;
      /* 移动 */
      _this.sliders.animate(
        {
          left: -current * _this.width + 'px',
        },
        1000,
        function () {
          _this.intervalTimer = interval();
          /* 圆点切换 */
          if (_this.dots) {
            _this.dots.children().removeClass(config.dotActiveClass);
            _this.dots.children().eq(_this.current).addClass(config.dotActiveClass);
          }
          animating = false;
        }
      );
    });

    this.next.on('click', function () {
      if (animating) return;
      animating = true;
      clearIntervalCustom(_this.intervalTimer);
      _this.intervalTimer = null;
      _this.current++;
      /* 移动 */
      _this.sliders.animate(
        {
          left: -_this.current * _this.width + 'px',
        },
        1000,
        function () {
          if (_this.current >= _this.sliders.children().length - 1) {
            _this.current = 0;
            _this.sliders.css('left', '0');
          }

          _this.intervalTimer = interval();

          /* 圆点切换 */
          if (_this.dots) {
            _this.dots.children().removeClass(config.dotActiveClass);
            _this.dots.children().eq(_this.current).addClass(config.dotActiveClass);
          }
          animating = false;
        }
      );
    });
  }

  function interval() {
    return setIntervalCustom(function () {
      _this.current++;

      var left = _this.current * _this.width;
      _this.sliders.animate(
        {
          left: -left + 'px',
        },
        1000,
        function () {
          if (_this.current >= _this.sliders.children().length - 1) {
            _this.current = 0;
            _this.sliders.css('left', '0');
          }
          /* 圆点切换 */
          if (_this.dots) {
            _this.dots.children().removeClass(config.dotActiveClass);
            _this.dots.children().eq(_this.current).addClass(config.dotActiveClass);
          }
        }
      );
    }, _this.interval);
  }

  function setIntervalCustom(func, time) {
    return setTimeout(function () {
      clearIntervalCustom(_this.intervalTimer);
      func();
      _this.intervalTimer = setIntervalCustom(func, time);
    }, time);
  }

  function clearIntervalCustom(timer) {
    clearTimeout(timer);
  }

  $(document).on('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      if (_this.intervalTimer) {
        clearIntervalCustom(_this.intervalTimer);
      }
    } else {
      _this.intervalTimer = interval();
    }
  });
}

module.exports = Sliders;



//////////////////
// WEBPACK FOOTER
// ./home/client/js/slider.js
// module id = 19
// module chunks = 3